import { createFileRoute, redirect } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"

export const Route = createFileRoute("/products")({
  validateSearch: (search: Record<string, unknown>): { action?: string } => ({
    action: (search.action as string) || undefined,
  }),
  beforeLoad: ({ location }) => {
    const hasChildRoute = location.pathname.split("/").filter(Boolean).length > 1
    if (hasChildRoute) return
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) throw redirect({ to: "/login" })
  },
})
